// カウントアップのアニメーションを制御する

import domReady from '../js-lib/domReady'
import inView from './inView'
import CounterUp from './CounterUp'

domReady(start)

function start () {
	inView.once(document.querySelector('#cnt01'), () => {
		[
			['.ct1-atx1', 1700],
			['.ct1-atx2', 1800],
			['.ct1-atx3', 1900],
			['.ct1-atx4', 1700],
		].forEach(setting => {
			const el = document.querySelector(setting[0])
			const duration = setting[1]
			const cu = new CounterUp(el, { duration })
			cu.start()
		})
	})
}
